export default {
      id: "i-legal-usage",
      viewBox: "0 0 51 51",
      url: __webpack_public_path__ + "img/sprite.svg#i-legal",
      toString: function () {
        return this.url;
      }
    }